export default __webpack_public_path__ + "static/subset-Inter-Regular-4d3b41a692b820006cdc440e9238715c.woff2";